export const DonateVariantsTipsTranslation = {
    en: `
&nbsp;&nbsp;&nbsp;&nbsp;This is the donation page setup. Your viewers will come here to see which interactive donation options you offer and choose how to support you.
<br><br><br>
&nbsp;&nbsp;&nbsp;&nbsp;Here you can add the options that will be available on the page.
You can choose the type of donation option (currently auction, roulette, or memes) and set your own title and description.
<br><br><br>
&nbsp;&nbsp;&nbsp;&nbsp;Each type has its own settings, such as the minimum donation amount, roulette spin cost, or meme price.
<br><br><br>
&nbsp;&nbsp;&nbsp;&nbsp;Options can be deleted completely or simply disabled. (This is an alternative to disabling the overlay, but only for a specific option.)
    `,
    uk: `
&nbsp;&nbsp;&nbsp;&nbsp;Це налаштування сторінки донатів. Тут ваші глядачі зможуть переглянути доступні інтерактивні варіанти донатів і вибрати спосіб підтримати вас.
<br><br><br>
&nbsp;&nbsp;&nbsp;&nbsp;Тут можна додавати варіанти, які будуть доступні на сторінці.
Можна обрати тип варіанта донату (зараз доступні аукціон, рулетка або меми), а також указати власні назву й опис.
<br><br><br>
&nbsp;&nbsp;&nbsp;&nbsp;Кожен тип має власні налаштування, як-от мінімальна сума донату, вартість обертання рулетки або ціна мему.
<br><br><br>
&nbsp;&nbsp;&nbsp;&nbsp;Варіанти можна повністю видалити або просто вимкнути. (Це альтернатива вимкненню оверлею, але лише для певного варіанта.)
    `
}
